export default __webpack_public_path__ + "static/media/harddrive.3e43b439.svg";